import {
  KpiKnowledgeInput,
  KpiKnowledgeView,
} from '../../../services/kpi-dashboard/kpi-dashboard.service'
import { normalizeSearchText } from '../../../util/search-text'

export interface KpiKnowledgeFormValue {
  name: string
  situation: string
  badResponse: string
  goodResponse: string
  reason: string
}

/** 5 項目を NFKC・小文字へ正規化して部分一致検索する。 */
export function filterKpiKnowledges(
  knowledges: readonly KpiKnowledgeView[],
  searchQuery: string,
): KpiKnowledgeView[] {
  const normalizedQuery = normalizeSearchText(searchQuery)
  if (normalizedQuery === '') {
    return [...knowledges]
  }

  return knowledges.filter((knowledge) =>
    normalizeSearchText(
      [
        knowledge.name,
        knowledge.situation,
        knowledge.badResponse,
        knowledge.goodResponse,
        knowledge.reason,
      ].join('\n'),
    ).includes(normalizedQuery),
  )
}

/** 検索中はヒット件数と全件数、未検索時は全件数を表示する。 */
export function formatKpiKnowledgeCount(
  filteredCount: number,
  totalCount: number,
  searchQuery: string,
): string {
  return normalizeSearchText(searchQuery) === ''
    ? `${totalCount}件`
    : `${filteredCount} / ${totalCount}件`
}

/** フォーム入力の前後空白を除去し、Mutation input に整形する。 */
export function buildKpiKnowledgeInput(
  value: KpiKnowledgeFormValue,
): KpiKnowledgeInput {
  return {
    name: value.name.trim(),
    situation: value.situation.trim(),
    badResponse: value.badResponse.trim(),
    goodResponse: value.goodResponse.trim(),
    reason: value.reason.trim(),
  }
}
